import classNames from 'classnames'
import React from 'react'
import { navigateBack } from '../../store/history/history.actions'
import RectangleActionButton, {
  COLOR_GREEN,
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM,
} from '../genericComponents/buttons/RectangleActionButton'
import LogoMappy from '../genericComponents/logo-mappy.svg'
import T from '../i18n/T'
import { useAction } from '../utils/react-redux'
import s from './ExpenseReport.less'

const ExpenseReportHeader = () => {
  const execNavigateBack = useAction(navigateBack)
  const onClickPrint = () => {
    window.print()
  }

  return (
    <div className={s.header}>
      <img src={LogoMappy} alt="Mappy" width="73" height="17" className={s.LogoMappy} />
      <h1>
        <T id={'itinerary.expense.title'} />
      </h1>
      <div className={classNames(s.block, s.actions)}>
        <RectangleActionButton
          color={COLOR_GREY_EMPTY}
          iconId="chevron"
          label="itinerary.expense.back"
          onClick={execNavigateBack}
          size={SIZE_MEDIUM}
        />
        <RectangleActionButton
          color={COLOR_GREEN}
          iconId="print"
          label="itinerary.expense.print"
          onClick={onClickPrint}
          size={SIZE_MEDIUM}
        />
      </div>
    </div>
  )
}

export default ExpenseReportHeader
